export const getCurrentUserFromStorage = () => {
    const user = localStorage.getItem('currentUser');
    return user ? JSON.parse(user) : null;
}

export const getInfoFromCurrentUser = (attribute) => {
    const user = getCurrentUserFromStorage();
    return user ? user[attribute] : null;
}